import { FC } from "react";

import InputForm from "./InputForm";
import SubmittedView from "./SubmittedView";
import { TSubmitInputProps } from "./types";

const SubmitInput: FC<TSubmitInputProps> = ({
  id,
  name,
  isSubmitted,
  value,
  submitLabel,
  removeLabel,
  onSubmit,
  onRemove,
  isDisabled,
  isLoading,
  ...rest
}) => {
  if (isSubmitted) {
    return <SubmittedView id={id || name} removeLabel={removeLabel} value={value} onRemove={onRemove} />;
  }

  return (
    <InputForm
      id={id || name}
      name={name}
      value={value}
      submitLabel={submitLabel}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onSubmit={onSubmit}
      {...rest}
    />
  );
};
export default SubmitInput;
